export default [
    {
        path: '/dataList/cookAllowance',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '厨师补贴',
            authLogin: true
        }
    },   
];